/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useReducer, useRef } from "react";
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
import { useVueProps } from "common/vue/useVueProps";
import { isTouchDevice } from "common/utils/browser";
import Stars from "common/vue/components/Stars.react.vue";
import { track } from "jiffy-analytics";
import PdpMadeReview from "./PdpMadeReview.vue";
import "./PdpMadeReviews.scss";
import { renderList } from "common/vue/render-list";
import ChevronDownIcon from "assets/icons/chevron-down.svg";

export default function PdpMadeReviews(rawProps: any) {
  const {
    className,
    rating: _rating,
    reviews: _reviews,
    reviewsCount: _reviewsCount,
    ...restProps
  } = rawProps;
  const [, forceUpdate] = useReducer(() => ({}), {});
  const isTooltipOpen = useRef(false);

  const props = useVueProps(rawProps);

  let timerId: any = null;
  const closeTooltip = () => {
    isTooltipOpen.current = false;
    forceUpdate();
    clearTimeout(timerId);
  };
  const openTooltip = () => {
    if (isTouchDevice()) return;
    timerId = setTimeout(() => {
      isTooltipOpen.current = true;
      forceUpdate();
      track("made_pdp_review_opened", {
        source: "Custom Apparel Reviews"
      });
    }, 500);
  };
  const toggleTooltip = () => {
    isTooltipOpen.current = !isTooltipOpen.current;
    forceUpdate();
  };
  const handleReviewLinkClick = () => {
    toggleTooltip();
    track("made_see_all_reviews_clicked", {
      source: "Custom Apparel Reviews"
    });
  };

  const rating = Number(props.current.rating);
  const reviewsCount = Number(props.current.reviewsCount);
  if (!Number.isFinite(rating) || rating <= 0) return null;
  if (!Number.isFinite(reviewsCount) || reviewsCount <= 0) return null;

  const formattedCount = reviewsCount.toLocaleString();
  const reviewWord = reviewsCount === 1 ? "review" : "reviews";

  return (
    <div
      {...(filterDomProps(restProps) as Record<string, unknown>)}
      className={cn("pdp-made-reviews scope-6f1e55c5", className)}
      onMouseLeave={closeTooltip}
      data-testid="pdp-made-reviews"
    >
      <div className={cn("pdp-made-reviews__widget", "scope-6f1e55c5")}>
        <button
          className={cn("pdp-made-reviews__rating", "scope-6f1e55c5")}
          type="button"
          onClick={toggleTooltip}
          onMouseEnter={openTooltip}
          data-testid="pdp-made-reviews-rating"
        >
          <Stars
            className={cn("js-feedback-label-tracker", "pdp-made-reviews__stars", "scope-6f1e55c5")}
            stars={rating}
            size="S"
            data-testid="pdp-made-reviews-stars"
          />
          <span className={cn("pdp-made-reviews__rating-score", "scope-6f1e55c5")}>
            {rating.toFixed(1)}
          </span>
          <span className={cn("pdp-made-reviews__rating-text", "scope-6f1e55c5")}>
            ({formattedCount} {reviewWord})
          </span>
          <ChevronDownIcon
            className={cn("pdp-made-reviews__tooltip-trigger-icon scope-6f1e55c5", {
              "pdp-made-reviews__tooltip-trigger-icon--flip": isTooltipOpen.current
            })}
            data-testid="pdp-made-reviews-tooltip-trigger-icon"
          />
        </button>
      </div>
      <div
        className={cn("pdp-made-reviews__tooltip scope-6f1e55c5", {
          hidden: !isTooltipOpen.current
        })}
      >
        <div className={cn("pdp-made-reviews__tooltip-inner", "scope-6f1e55c5")}>
          <header className={cn("pdp-made-reviews__tooltip-header", "scope-6f1e55c5")}>
            <h4 className={cn("pdp-made-reviews__tooltip-header-title", "scope-6f1e55c5")}>
              Latest Reviews
            </h4>
            <a
              className={cn("pdp-made-reviews__tooltip-header-link", "scope-6f1e55c5")}
              data-testid="pdp-made-reviews-see-all-link"
              href="#reviews-summary"
              onClick={handleReviewLinkClick}
            >
              {" "}
              See all customer reviews{" "}
            </a>
          </header>
          <div className={cn("pdp-made-reviews__tooltip-body", "scope-6f1e55c5")}>
            <div className={cn("pdp-made-reviews__wrapper", "scope-6f1e55c5")}>
              {renderList(props.current.reviews, review => (
                <PdpMadeReview
                  className={cn("scope-6f1e55c5")}
                  key={review}
                  review={review}
                  toggleTooltip={toggleTooltip}
                  data-testid="pdp-made-review"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
